import { render, staticRenderFns } from "./Func20.vue?vue&type=template&id=fb3dde98"
import script from "./Func20.vue?vue&type=script&lang=js"
export * from "./Func20.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports